<template>
  <div class="site-wrap">
    <podcasts-header />

    <div
      class="site-blocks-cover overlay inner-page-cover"
      style="background-image: url(/images/hero_bg_2.jpg)"
      data-aos="fade"
      data-stellar-background-ratio="0.5"
    >
      <div class="container">
        <div class="row align-items-center justify-content-center text-center">
          <div  v-show="isLoading" class="col-md-8" data-aos="fade-up" data-aos-delay="5">
            <h2 class="text-white font-weight-light mb-2 display-4">loading podcast...</h2>
          </div>
          <div class="col-md-8" data-aos="fade-up" data-aos-delay="400">
            <h2 v-show="!isLoading"class="text-white font-weight-light mb-2 display-4"> {{ podcast.title }}</h2>
            <div v-show="!isLoading" class="text-white mb-3">
              <span class="text-white-opacity-05">
                <small>
                  By {{ podcast.producerName }}
                  <span class="sep">/</span>
                  {{ podcast.publishedDate | formatDate }}
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!isLoading" class="container site-section">
      <div class="player mb-5">
        <audio id="player2" preload="none" controls style="max-width: 100%">
          <source :src="podcast.mp3" type="audio/mp3" />
        </audio>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-10">
          <p>
            <span v-html="podcast.description"></span>
          </p>
        </div>
      </div>
    </div>
    <podcasts-footer />
  </div>
</template>

<script>
import PodcastsFooter from "./PodcastsFooter";
import PodcastsHeader from "./PodcastsHeader";

export default {
  name: "Podcast",
  components: { PodcastsFooter, PodcastsHeader },
  data() {
    return { podcast: { mp3: "" }, isLoading: true };
  },
  methods: {
    async loadPodcast(id) {
      if (!id) id = 1;
      const resp = await fetch(`/api/shows/${id}`);
      if (!resp.ok) this.$router.push("/"); 
      const json = await resp.json();
      this.podcast = json;
    },
    setMediaelements() {
      let mediaElements = document.querySelectorAll("video, audio"),
        total = mediaElements.length;

      for (let i = 0; i < total; i++) {
        new MediaElementPlayer(mediaElements[i], {
          pluginPath: "https://cdn.jsdelivr.net/npm/mediaelement@4.2.7/build/",
          shimScriptAccess: "always",
          success: function () {
            var target = document.body.querySelectorAll(".player"),
              targetTotal = target.length;
            for (var j = 0; j < targetTotal; j++) {
              target[j].style.visibility = "visible";
            }
          },
        });
      }
    },
  },
  async created() {
    this.isLoading = true;
    let id = this.$route.params.id.split("-")[0];
    await this.loadPodcast(id);
    this.setMediaelements();
    this.isLoading = false;      
  },
};
</script>
